/// <reference path="../../../app.definition.ts" />
// typescript namespace
import angular from "angular";
import { Util } from "@common/util";
import { IAppRootScopeService } from "@/app/app.definition";
import { CacheService } from "@common/service/cache.service";
import { PopUpService } from "@common/popup/popup.service";
import { PushNotificationService } from "@common/service/push-notification.service";
import { WebSocketService } from "@common/service/web-socket.service";
import { BroadcastService } from "@common/service/broadcast.service";

// define & export class
export class PasswordCollectorService {
    openPasswordModal: (createPassword? : boolean,
                        fromProfile? : boolean,
                        showBg? : boolean,
                        sessionTimeout? : boolean) => any;
    openChangePasswordModal;
    openExpiredPasswordModal;
    openInitPasswordsModal;
    closePasswordsModal;
    initCallbacks: Array<{ key: string; fn: Function }>;
    init;
    onSuccessfullLogin;
    fromProfile;
    currentUIModel;
    static $inject = [
        "$rootScope",
        "CacheService",
        "$uibModal",
        "$q",
        "PopUpService",
        "$timeout",
        "PushNotificationService",
        "WebSocketService",
        "BroadcastService",
    ];
    takingPasswordFirstTime;
    constructor(
        $rootScope: IAppRootScopeService,
        CacheService: CacheService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $q: ng.IQService,
        PopUpService: PopUpService,
        $timeout: angular.ITimeoutService,
        PushNotificationService: PushNotificationService,
        WebSocketService: WebSocketService,
        BroadcastService: BroadcastService
    ) {
        this.takingPasswordFirstTime = null;
        this.initCallbacks = [];
        let notifyForDesktopNotification = () => {
            $timeout(() => {
                if (!("Notification" in window)) {
                    toastr.success(Util.DESKTOP_NOTIFICATION_NOT_SUPPORTED, {
                        timeOut: 3000,
                    });
                } else if (Notification.permission !== "granted") {
                    Notification.requestPermission();
                }
            }, 1500);
        };
        this.onSuccessfullLogin = () => {
            let redirectFlow = $rootScope.redirectFlow;
            if (!!redirectFlow) {
                switch (redirectFlow.type.toLowerCase()) {
                    case "notification":
                        let notifications = CacheService.getPushNotifications();
                        if (!!notifications) {
                            let notiObj = notifications.find(
                                (n) => n.id == redirectFlow.id
                            );
                            if (
                                redirectFlow.userId ==
                                CacheService.getUser().userId
                            ) {
                                if (!!notiObj) {
                                    PushNotificationService.openEntity(notiObj);
                                }
                            } else {
                                toastr.success(
                                    Util.NOTIFICATION_FOR_OTHER_USER,
                                    { timeOut: 1500 }
                                );
                            }
                        }
                        break;
                    default:
                        break;
                }
                delete $rootScope.redirectFlow;
            }
            notifyForDesktopNotification();
        };

        this.closePasswordsModal = () => { };

        this.openInitPasswordsModal = () => {
            this.init = true;

            PopUpService.closeCurrentModal();
            $rootScope.showSolidBg = true;
            let deferred = $q.defer();
            $uibModal
                .open({
                    templateUrl:
                        "app/common/passwordCollector/components/password-collector.html",
                    controller:
                        "PasswordCollectorController as passwordCollectorVm",
                    backdrop: "static",
                    keyboard: false,
                    windowClass: "password-modal",
                    resolve: {
                        CreatePassword: () => "init",
                        ChangePassword: () => false,
                        fromProfile: () => false,
                        resetRequired: () => false,
                        resetRequiredMessage: () => null,
                    },
                })
                .result.then(
                    (success) => {
                        $rootScope.showSolidBg = false;
                        this.onSuccessfullLogin();
                        deferred.resolve(success);
                    },
                    (error) => {
                        $rootScope.showSolidBg = true;
                        deferred.reject(error);
                    }
                );

            return deferred.promise;
        };
        this.openPasswordModal = (
            createPassword?,
            fromProfile?,
            showBg?,
            sessionTimeout?
        ) => {
            // close the existing password modal if already open WEB-7164
            let passwordPopup = angular.element(".password-modal");
            if (passwordPopup.length > 0) {
                (
                    passwordPopup.scope() as any
                ).passwordCollectorVm.$uibModalInstance.dismiss();
            }
            this.init = false;
            PopUpService.closeCurrentModal();
            if (!!createPassword) createPassword = true;
            else createPassword = false;
            $rootScope.showSolidBg = showBg == false ? showBg : true;
            if (!!sessionTimeout) {
                WebSocketService.reset();
            }
            let deferred = $q.defer();
            $uibModal
                .open({
                    templateUrl:
                        "app/common/passwordCollector/components/password-collector.html",
                    controller:
                        "PasswordCollectorController as passwordCollectorVm",
                    backdrop: "static",
                    windowClass: "password-modal",
                    keyboard: false,
                    resolve: {
                        CreatePassword: () => createPassword,
                        ChangePassword: () => false,
                        fromProfile: () => fromProfile,
                        resetRequired: () => false,
                        resetRequiredMessage: () => null,
                    },
                })
                .result.then(
                    (success) => {
                        CacheService.setNotFirstTime(true);
                        if (!!sessionTimeout) {
                            WebSocketService.createSocket();
                        }
                        BroadcastService.broadcast("password-taken");
                        $rootScope.showSolidBg = false;
                        this.onSuccessfullLogin();
                        deferred.resolve(success);
                    },
                    (error) => {
                        //$rootScope.showSolidBg = false;
                        deferred.reject(error);
                    }
                );
            return deferred.promise;
        };

        this.openChangePasswordModal = (showBg?) => {
            this.init = false;
            PopUpService.closeCurrentModal();
            $rootScope.showSolidBg = showBg == false ? showBg : true;
            let deferred = $q.defer();
            $uibModal
                .open({
                    templateUrl:
                        "app/common/passwordCollector/components/password-collector.html",
                    controller:
                        "PasswordCollectorController as passwordCollectorVm",
                    backdrop: "static",
                    keyboard: false,
                    windowClass: "password-modal",
                    resolve: {
                        ChangePassword: () => true,
                        CreatePassword: () => false,
                        fromProfile: () => false,
                        resetRequired: () => false,
                        resetRequiredMessage: () => null,
                    },
                })
                .result.then(
                    (success) => {
                        $rootScope.showSolidBg = false;
                        this.onSuccessfullLogin();
                        deferred.resolve(success);
                    },
                    (error) => {
                        //$rootScope.showSolidBg = true;
                        deferred.reject(error);
                    }
                );
            return deferred.promise;
        };

        this.openExpiredPasswordModal = (showBg?) => {
            this.init = false;
            let passwordPopup = angular.element(".password-modal");
            if (passwordPopup.length > 0) {
                (
                    passwordPopup.scope() as any
                ).passwordCollectorVm.$uibModalInstance.dismiss();
            }
            PopUpService.closeCurrentModal();
            $rootScope.showSolidBg = showBg == false ? showBg : true;
            let deferred = $q.defer();
            $uibModal
                .open({
                    templateUrl:
                        "app/common/passwordCollector/components/password-collector.html",
                    controller:
                        "PasswordCollectorController as passwordCollectorVm",
                    backdrop: "static",
                    keyboard: false,
                    windowClass: "password-modal",
                    resolve: {
                        ChangePassword: () => false,
                        CreatePassword: () => false,
                        fromProfile: () => false,
                        resetRequired: () =>
                            CacheService.isVaultKeyResetRequired(),
                        resetRequiredMessage: () =>
                            CacheService.getVaultKeyResetRequiredMessage(),
                    },
                })
                .result.then(
                    (success) => {
                        $rootScope.showSolidBg = false;
                        BroadcastService.broadcast("password-taken");
                        this.onSuccessfullLogin();
                        deferred.resolve(success);
                    },
                    (error) => {
                        //  $rootScope.showSolidBg = true;
                        deferred.reject(error);
                    }
                );
            return deferred.promise;
        };
    }

    addVaultKeyCallback(key: string, fn: Function): void {
        let cb = this.initCallbacks.find((k) => k.key == key);

        if (cb) {
            cb.fn = fn;
        } else {
            this.initCallbacks.push({ key: key, fn: fn });
        }
    }

    removeVaultKeyCallback(key: string): void {
        let cb = this.initCallbacks.findIndex((k) => k.key == key);

        if (cb >= 0) {
            this.initCallbacks.splice(cb, 1);
        }
    }

    notifyVaultKeyCallbacks(credentials: boolean): void {
        for (let cbo of this.initCallbacks) {
            cbo.fn(credentials);
        }
    }
}

angular
    .module("eCareVault.common.passwordCollector")
    .service("PasswordCollectorService", PasswordCollectorService);
